import * as React from "react";
import { SkeletonWrapper } from "src/components/Skeleton/SkeletonWrapper.component";
import styled from "styled-components";

type TableSkeletonProps = {
  rows?: number;
};

const TableRowEl = styled.div`
  height: 48px;

  :nth-child(even) {
    background-color: rgb(249, 249, 249);
  }
`;

export const SkeletonTable = (props: TableSkeletonProps) => (
  <SkeletonWrapper>
    {new Array(props.rows || 5).fill(null).map((_, i) => (
      <TableRowEl key={i} />
    ))}
  </SkeletonWrapper>
);
